/**
 * Fancy conditional rendering.
 *
 * @param condition Truthy/Falsy value to be evaluated.
 * @param render Render function to be called if condition is truthy.
 */
export const when = (condition, render) =>
  condition ? render(condition) : null;
export default when;
